<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>

@for (text of texts; track text) {
  <div id="questionLists" class="col-md-10 mt-5">
    <p>
      {{ text.text1 }}
    </p>
    <p>
      {{ text.text2 }}
    </p>
    <p>
      <b>
        {{ text.text3 }}
      </b>
    </p>
    <p>{{ text.text4 }}</p>
    <ol>
      <p>
        <li>{{ text.listtext1 }}</li>
        <li>{{ text.listtext2 }}</li>
        <li>{{ text.listtext3 }}</li>
      </p>
    </ol>
    <h2>
      {{ text.title }}
    </h2>
    <p>{{ text.paragraph1 }}</p>
    <p>{{ text.paragraph2 }}</p>
    <p>{{ text.paragraph3 }}</p>
    <ul>
      <p>
        <li>{{ text.list1 }}</li>
        <li>{{ text.list2 }}</li>
        <li>{{ text.list3 }}</li>
      </p>
    </ul>
  </div>
}
